import React, {useEffect, useState} from 'react';
import 'datatables.net';
import 'datatables.net-responsive';
import {GET_COLLECTION_AGGREGATE_DATA, GET_COLLECTION_DATA} from '../../../api';
import $ from "jquery";
import {capitalize} from "../../../utils/capitalize";
import cogoToast from "cogo-toast";
import {getAccountBalance, withdraw, getZones} from "../../../api/app";
import moment from "moment";
import formatNumber from "../../../utils/formatNumber";
import {useSelector} from "react-redux";
import exportToExcel from "../../../utils/exporter";
import networks from "../../../data/networks.json";

let selectedArea = [];
let currentDateRange = null;
let total = 0;

const Settlement = () => {

    document.title = "Settlements";

    const auth = useSelector((state) => state.auth.user);
    const token = localStorage.getItem('jwtToken');
    const [exportLoading, setExportLoading] = useState(false);
    const [randomTime, setRandomTime] = useState(new Date().getTime());
    const [stateReady, setStateReady] = useState(false);
    const [network, setNetwork] = useState([]);

    useEffect(() => {
        getAccountBalance().then((response) => {
            $('#total-balance').text(auth.user.country.currency.symbol+formatNumber(response.payload.balance - response.payload.totalTransferFees));
            $('#total-payout').text("-"+auth.user.country.currency.symbol+formatNumber(response.payload.totalPayoutAmount));
        })
    }, [randomTime]);

    useEffect(() => {
        let table = $('#td-transaction').DataTable({
            responsive: true,
            "language": {
                "processing": '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Collecting Settlement Report</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                // make a regular ajax request using data.start and data.length
                $.ajax(GET_COLLECTION_AGGREGATE_DATA, {
                    type: 'POST',
                    headers: {
                        "Authorization": token
                    },
                    data: {
                        query: $('.dataTables_filter input').val(),
                        collection: "payout",
                        searchableFields: [
                            { field: 'gateway', isNumeric: false },
                            { field: 'amount', isNumeric: true }
                        ],
                        pageSize: data.start,
                        format: 'json',
                        populate: [
                            {
                                path: "collector",
                                model: "collector"
                            }
                        ],
                        pageIndex: (data.length + data.start) / data.length
                    },
                    success: function (res) {
                        let array = [];
                        total = res.total;
                        res.data.map((data) => {
                            array.push({raw: data})
                        });
                        callback({
                            recordsTotal: res.total,
                            recordsFiltered: res.total,
                            data: array
                        });
                    },
                    error: function(err) {
                        cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
                    }
                });
            },
            "columns": [
                {
                    className: 'dt-control',
                    orderable: false,
                    data: null,
                    defaultContent: '',
                },
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"},
                {"data": "raw"}
            ],
            "columnDefs": [
                {
                    "render": function () {
                        return null;
                    },
                    "targets": 0
                },
                {
                    "render": function (data) {
                        return `${auth.user.country.currency.symbol}${formatNumber(data.amount)}`;
                    },
                    "targets": 1
                },
                {
                    "render": function (data) {
                        return `<span class="tx-danger tx-bold">-${auth.user.country.currency.symbol}${data?.transfer_fee || "0"}</span>`;
                    },
                    "targets": 2
                },
                {
                    "render": function (data) {
                        return capitalize(data.gateway);
                    },
                    "targets": 3
                },
                {
                    "render": function (data) {
                        return `<span class="tx-primary">${moment(data.period.start.str).format("Do MMM, YYYY")}</span> - <span class="tx-danger">${moment(data.period.end.str).format("Do MMM, YYYY")}</span>`
                    },
                    "targets": 4
                },
                {
                    "render": function (data) {
                        return moment(data.date.str).format("Do MMM, YYYY HH:mm")
                    },
                    "targets": 5
                }
            ]
        });

        $('#td-transaction tbody').on('click', 'td.dt-control', function () {
            let tr = $(this).closest('tr');
            let row = table.row(tr);

            if (row.child.isShown()) {
                // This row is already open - close it
                row.child.hide();
                tr.removeClass('shown');
            } else {
                // Open this row
                row.child(format(row.data())).show();
                tr.addClass('shown');
            }
        });

        function format(d) {
            // `d` is the original data object for the row
            return (
                '<table cellpadding="5" cellspacing="0" border="0" style="padding-left:50px;">' +
                '<tr>' +
                '<td>Reference #:</td>' +
                '<td>'+ `${d.raw?.ref_number.toUpperCase() || "No Data"}` +'</td>' +
                '<tr>' +
                '<td>Transaction ID:</td>' +
                '<td>'+ `${d.raw?.metadata?.transaction_id.toUpperCase() || "No Data"}` +'</td>' +
                '</tr>' +
                '<td>Account Number:</td>' +
                '<td>'+ `${d.raw?.metadata?.account_number || "No Data"}` +'</td>' +
                '</tr>' +
                '<td>Network:</td>' +
                '<td>'+ `${d.raw?.metadata?.network || "No Data"}` +'</td>' +
                '</tr>' +
                '</table>'
            );
        }

        return () => {
            selectedArea = [];
            currentDateRange = null;
            total = 0;
            table.destroy();
        }

    }, []);

    const exportData = () => {
        setExportLoading(true);
        $.ajax(GET_COLLECTION_DATA, {
            type: 'POST',
            headers: {
                "Authorization": token
            },
            data: {
                collection: "payout",
                fieldname: "type",
                limit: total,
                pageSize: 0,
                filter: {
                    collector: auth.user._id
                },
                format: 'json',
                populate: "collector"
            },
            success: function (res) {
                setExportLoading(false);
                const filteredData = res.data.map(item => ({
                    amount: item.amount,
                    gateway: capitalize(item.gateway),
                    status: item.transfer_fee,
                    start_period: moment(item.period.start.str).format("Do MMM, YYYY"),
                    end_period: moment(item.period.end.str).format("Do MMM, YYYY"),
                    date_issued: moment(item.date.str).format("Do MMM, YYYY"),
                }));

                const headers = [
                    "Amount",
                    "Source",
                    "Transfer Fee",
                    "Start Period",
                    "End Period",
                    "Date Issued"
                ];

                exportToExcel(headers, filteredData, "Settlement");
            },
            error: function(err) {
                cogoToast.error( err.responseJSON['error'].details !== undefined ? err.responseJSON['error'].details[0].message : err.responseJSON['error'], {position: "top-right", hideAfter: 5});
            }
        });
    }

    const handlePayoutSubmit = (e) => {
        e.preventDefault();

        setStateReady(true);

        let data = {
            amount:$('#amount').val(),
            account_number: $('#account-number').val(),
            network: $('#network').val(),
            gateway: $('#gateway').val()
        };

        withdraw(data).then((result) => {
            setStateReady(false);
            if(!result.error) {
                cogoToast.success(result.payload, {position: "top-right", hideAfter: 5});
                resetForm("modalPayout", "payout_form");
                reloadTable();
            }
        });
    }

    const handleShowModal = () => {
        $('#payout_form').parsley();
        $("#modalPayout").modal({ backdrop: 'static', focus: false, show: true });
    };

    const resetForm = (id, form) => {
        const parsley = $(`#${form}`).parsley();
        $(':input',`#${form}`)
            .not(':button, :submit, :reset, :hidden')
            .val('')
            .prop('checked', false)
            .prop('selected', false);
        $(`#${id}`).modal("hide");
        parsley.reset();
        parsley.destroy();
        $(".modal-backdrop").remove();
    };

    const reloadTable = () => {
        setRandomTime(new Date().getTime())
        $('#td-transaction').DataTable().ajax.reload(null, false);
    }

    const handlePayment = (e) => {
        $("#label-number").text(e.target.value === "momo" ? "Mobile Number" : "Account Number");
        setNetwork(networks.filter((item) => item.type === e.target.value));
        $("#network").val('');
    }

    return (
        <div className="content-body">
            <div className="container-fluid pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item active" aria-current="page">Settlements</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Settlements</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-12">
                        <div className="card card-body">
                            <div className="d-md-flex align-items-center justify-content-between">
                                <div className="media align-sm-items-center">
                                    <div className="tx-40 tx-lg-60 ht-55 lh-0">
                                        <a href="" className="avatar">
                                            <img src="assets/img/wallet.svg" className="rounded-circle" alt=""/></a>
                                    </div>
                                    <div className="media-body mg-l-15 my-auto">
                                        <h6 className="tx-12 tx-lg-14 tx-semibold tx-uppercase tx-spacing-1 mg-b-5">Withdraw Balance <span className="tx-normal tx-color-03">({auth.user.country.currency.code})</span></h6>
                                        <div className="d-flex align-items-baseline">
                                            <h2 className="tx-20 tx-lg-28 tx-normal tx-rubik tx-spacing--2 lh-2 mg-b-0" id="total-balance">K0.00</h2>
                                            <h6 className="tx-11 tx-lg-16 tx-normal tx-rubik tx-danger mg-l-5 lh-2 mg-b-0" id="total-payout">Checking Balance</h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex flex-column flex-sm-row mg-t-20 mg-md-t-0">
                                    <button className="btn btn-sm btn-white btn-uppercase pd-x-15 mg-t-5 mg-sm-t-0  mg-sm-l-5" onClick={handleShowModal.bind()}><i className="mg-r-5 fa fa-arrow-up"></i> Withdraw</button>
                                    {exportLoading ? <button disabled className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/> Exporting</button> : <button className="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" onClick={exportData.bind()}><i className="wd-10 mg-r-5 fa fa-upload"></i> Export</button>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Settlements</h6>
                                <div className="d-flex tx-18">
                                    <a href="javascript:void(0)" onClick={reloadTable.bind()} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></a>
                                </div>
                            </div>
                            <div className="card-body">
                                <table id="td-transaction" className="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th className="wd-20p">Amount</th>
                                        <th className="wd-20p">Transfer Fee</th>
                                        <th className="wd-20p">Source</th>
                                        <th className="wd-20p">Period</th>
                                        <th className="wd-20p">Date Issued</th>
                                    </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalConfirm" tabIndex="-1" role="dialog" aria-labelledby="confirmation"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-sm" role="document">
                    <div className="modal-content tx-14">
                        <div className="modal-header">
                            <h6 className="modal-title" id="exampleModalLabel6">Delete Confirm?</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="mg-b-0 data-message">Empty</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" id="delete-data" className="btn btn-success btn-block">Yes, Delete
                            </button>
                            <button type="button" className="btn btn-danger btn-block mt-0"
                                    data-dismiss="modal">Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade" id="modalPayout" tabIndex="-1" role="dialog" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered wd-sm-650" role="document">
                    <div className="modal-content">
                        <div className="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
                            <a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </a>
                            <div className="media-body"><a href="#" role="button" className="close pos-absolute t-15 r-15" data-dismiss="modal" onClick={resetForm.bind(null, "modalPayout", "payout_form")} aria-label="Close"><span aria-hidden="true">×</span></a><h4 className="tx-18 tx-sm-20 mg-b-2">Withdraw</h4><p className="tx-13 tx-color-02 mg-b-0">Create payout information.</p></div>
                        </div>
                        <div className="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
                            <form id="payout_form" className="parsley-style-1" onSubmit={handlePayoutSubmit.bind()}>
                                <div id="typeWrapper" className="form-group parsley-input">
                                    <label>Mode of Payment<span className="tx-danger">*</span></label>
                                    <select className="custom-select" id="gateway" required onChange={handlePayment.bind()}>
                                        <option value="" disabled selected>Select</option>
                                        <option value="momo">Mobile Money</option>
                                        <option value="bank">Bank</option>
                                    </select>
                                </div>

                                <div id="typeWrapper" className="form-group parsley-input">
                                    <label>Network<span className="tx-danger">*</span></label>
                                    <select className="custom-select" id="network" required>
                                        <option value="" disabled selected>Select</option>
                                        {network.slice().sort((a, b) => a.name.localeCompare(b.name)).map((item, index) => (
                                            <option key={index} value={item.value}>{item.name}</option>
                                        ))}
                                    </select>
                                </div>

                                <div id="accountNumberWrapper" className="form-group parsley-input">
                                    <label id="label-number">Account Number</label>
                                    <input id="account-number" type="number" className="form-control"
                                           placeholder="Enter number"
                                           autoComplete="none"
                                           data-parsley-class-handler="#accountNumberWrapper"
                                           required
                                    />
                                </div>

                                <div id="amountWrapper" className="form-group parsley-input">
                                    <label>Amount<span className="tx-danger">*</span></label>
                                    <input id="amount" type="number" className="form-control"
                                           placeholder="Enter amount"
                                           autoComplete="none"
                                           step="0.01"
                                           data-parsley-class-handler="#amountWrapper"
                                           required/>
                                </div>

                                {stateReady ? <button disabled className="btn btn-success btn-block"><span className="spinner-border spinner-border-sm mg-r-10" role="status" aria-hidden="true"/>Please Wait</button> : <button className="btn btn-success btn-block">Withdraw</button>}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Settlement;
